import Icon from '@components/Icon';
// import { CommentIcon } from '@components/Icons/CommentIcon.';
// import { FavoriteIcon } from '@components/Icons/FavoriteIcon';
// import { OptionsIcon } from '@components/Icons/OptionsIcon';
// import { SavedIcon } from '@components/Icons/SavedIcon';
import { useRef, useState } from 'react';
import { formatPublishedTime } from '../../../../utils/timeFormatter';

interface PhotoData {
  filename: string;
  description: string;
  instagramPost: string;
  likesCount: number;
  commentsCount: number;
  publishedAt?: number;
}

interface FeedPhotoItemProps {
  bgStyle?: string;
  photoData?: PhotoData;
  imageUrl?: string;
  videoUrl?: string;
}

export const FeedPhotoItem = ({
  bgStyle = 'bg-[linear-gradient(180deg,rgba(41,47,255,0.2)_0%,rgba(41,47,255,0)_100%)]',
  photoData = {
    filename: '1.jpg',
    description: 'Default photo description',
    instagramPost: 'Default Instagram post',
    likesCount: 4100,
    commentsCount: 3200,
  },
  imageUrl = 'https://napstermusicstoragedev.blob.core.windows.net/music/contributors/91abcddd-1c5f-43b9-ab14-982f30461a1d/albums/08760502-091b-4f95-9bec-2e0a977492f8/08760502-091b-4f95-9bec-2e0a977492f8.jpg',
  videoUrl,
}: FeedPhotoItemProps) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const handleVideoClick = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
        setIsPlaying(false);
      } else {
        videoRef.current.play();
        setIsPlaying(true);
      }
    }
  };

  const handleMouseEnter = () => {
    if (videoRef.current && !isPlaying) {
      videoRef.current.muted = true;
      videoRef.current.play();
    }
  };

  const handleMouseLeave = () => {
    if (videoRef.current && !isPlaying) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
    }
  };

  const handleVideoPlay = () => {
    setIsPlaying(true);
  };

  const handleVideoPause = () => {
    setIsPlaying(false);
  };
  return (
    <div
      className={`w-full ${bgStyle} rounded-[16px] pb-[16px] font-[NapsterSans]`}>
      <div className="flex p-4 w-full gap-2 items-center">
        <div className="flex w-[36px] h-[36px]">
          <img
            className="w-full h-full object-cover"
            src="https://napsteraimusic-dyewfxh4abb6ataq.z02.azurefd.net/aimusic/contributors/73d9cac0-21a2-4e14-9762-58ccb4e93ee0/73d9cac0-21a2-4e14-9762-58ccb4e93ee0.jpg"
            alt="User"
          />
        </div>
        <div className="flex flex-col flex-1 font-[NapsterSans]">
          <div className="flex text-[14px] font-semibold leading-[130%] text-left text-white pb-[2px]">
            Nyx
          </div>
          <div className="flex gap-[5px] items-center">
            <div className="flex text-[12px] font-normal leading-[130%] text-left text-white/60 pb-[2px]">
              @nyx
            </div>
            <div className="flex text-[12px] font-normal leading-[130%] text-left text-white/60">
              •{' '}
              {photoData.publishedAt
                ? formatPublishedTime(photoData.publishedAt)
                : 'now'}
            </div>
          </div>
        </div>
        <div className="flex">{/* <OptionsIcon opacityValue={0.8} /> */}</div>
      </div>

      <div className="w-full p-4 pt-[0] text-[14px] font-normal leading-[130%] text-left text-white font-[NapsterSans]">
        {photoData.instagramPost}
      </div>

      <div className="flex w-full relative px-4 pb-4">
        <div
          className="flex w-full h-full shadow-[0_4px_32px_0_rgba(0,0,0,0.4)] relative"
          onMouseEnter={videoUrl ? handleMouseEnter : undefined}
          onMouseLeave={videoUrl ? handleMouseLeave : undefined}>
          {videoUrl ? (
            <>
              <video
                ref={videoRef}
                className="w-full h-full rounded-[8px] object-cover cursor-pointer"
                src={videoUrl}
                muted
                loop
                autoPlay={false}
                playsInline
                onClick={handleVideoClick}
                onPlay={handleVideoPlay}
                onPause={handleVideoPause}
              />
              {!isPlaying && (
                <div
                  className="absolute bottom-3 left-3 cursor-pointer"
                  onClick={handleVideoClick}>
                  <div className="w-10 h-10 flex items-center justify-center ">
                    <Icon name="play" size={16} color="white" />
                  </div>
                </div>
              )}
            </>
          ) : (
            <img
              className="w-full h-full rounded-[8px]"
              src={imageUrl}
              alt={photoData.filename}
            />
          )}
        </div>
      </div>

      {/* <div className="w-full text-[12px] font-medium leading-[130%] text-white text-center pb-3">
        {photoData.instagramPost}
      </div> */}

      {/* <div className="flex w-full gap-[4px] relative z-[1] pt-4 px-4">
        <button className="flex items-center gap-[4px] h-[28px] border-1 border-white/20 w-fit px-3 rounded-full">
          <FavoriteIcon width={16} height={16} fillOpacity={0.8} />
          <span className="text-[10px] font-normal leading-[140%] text-white text-left">
            {photoData.likesCount > 1000
              ? `${(photoData.likesCount / 1000).toFixed(1)}K`
              : photoData.likesCount.toString()}
          </span>
        </button>

        <button className="flex items-center gap-[4px] h-[28px] border-1 border-white/20 w-fit px-3 rounded-full">
          <CommentIcon />

          <span className="text-[10px] font-normal leading-[140%] text-white text-left">
            {photoData.commentsCount > 1000
              ? `${(photoData.commentsCount / 1000).toFixed(1)}K`
              : photoData.commentsCount.toString()}
          </span>
        </button>

        <button className="flex items-center gap-[4px] h-[28px] border-1 border-white/20 w-fit px-3 rounded-full">
          <SavedIcon />

          <span className="text-[10px] font-normal leading-[140%] text-white text-left">
            1.6K
          </span>
        </button>
      </div> */}
    </div>
  );
};
